var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAtencion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20977",
    "data-name": "Grupo 20977",
    transform: "translate(-914 -403)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_264",
    "data-name": "Elipse 264",
    cx: 46,
    cy: 46,
    r: 46,
    transform: "translate(914 403)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "warning-circle-svgrepo-com",
    d: "M29.016,43.44v.029m0-28.907V34.8m26.016-5.781A26.016,26.016,0,1,1,29.016,3,26.016,26.016,0,0,1,55.032,29.016Z",
    transform: "translate(930.984 420.5)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAtencion);
export default __webpack_public_path__ + "static/media/icon-atencion.f78097bff32c128b3964e91c202c3f2d.svg";
export { ForwardRef as ReactComponent };